/* Quest One v2 · scene and screen effects (window.QOFx)
   Living painted scenes (weather, light, slow drift), screen feedback (shake, flash, crack),
   flying modifier chips, the share card renderer and an in-app-browser-safe save overlay.
   Framework free. Every effect degrades to a still, readable state under reduced motion. */
(function () {
  'use strict';
  var RM = function () {
    try { return document.documentElement.classList.contains('qo-reduced') || window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  };
  var DPR = function () { return Math.min(2, window.devicePixelRatio || 1); };

  /* ---------- Living scene ---------- */
  function Weather(canvas, kind) {
    this.c = canvas; this.ctx = canvas.getContext('2d'); this.kind = kind; this.p = []; this.t = 0; this.raf = 0; this.alive = true;
    this.resize(); var self = this;
    this.onResize = function () { self.resize(); };
    window.addEventListener('resize', this.onResize);
    this.onVis = function () { if (document.hidden) cancelAnimationFrame(self.raf); else self.loop(); };
    document.addEventListener('visibilitychange', this.onVis);
    this.seed(); this.loop();
  }
  Weather.prototype.resize = function () {
    var r = this.c.getBoundingClientRect(), d = DPR();
    this.w = Math.max(1, r.width); this.h = Math.max(1, r.height);
    this.c.width = Math.round(this.w * d); this.c.height = Math.round(this.h * d);
    this.ctx.setTransform(d, 0, 0, d, 0, 0);
  };
  Weather.prototype.seed = function () {
    var n = { rain: 90, embers: 26, fireflies: 16, dust: 30, wisps: 7, snow: 60, ash: 40 }[this.kind] || 0;
    if (window.innerWidth < 600) n = Math.round(n * 0.6);
    this.p = [];
    for (var i = 0; i < n; i++) this.p.push(this.make(true));
  };
  Weather.prototype.make = function (initial) {
    var w = this.w, h = this.h, k = this.kind, R = Math.random;
    if (k === 'rain') return { x: R() * w * 1.2, y: initial ? R() * h : -20, v: 520 + R() * 260, l: 10 + R() * 14, a: 0.12 + R() * 0.22 };
    if (k === 'embers' || k === 'ash') return { x: R() * w, y: initial ? R() * h : h + 10, vx: (R() - 0.5) * 14, vy: -(18 + R() * 34), s: 1 + R() * 2.2, a: 0.4 + R() * 0.5, ph: R() * 6.28, life: R() };
    if (k === 'fireflies') return { x: R() * w, y: h * (0.35 + R() * 0.6), ph: R() * 6.28, sp: 0.4 + R() * 0.6, s: 1.4 + R() * 1.6 };
    if (k === 'wisps') return { x: R() * w, y: h * (0.45 + R() * 0.4), ph: R() * 6.28, sp: 0.15 + R() * 0.2, s: 3 + R() * 3 };
    if (k === 'dust') return { x: R() * w, y: R() * h, vx: 4 + R() * 10, vy: (R() - 0.5) * 4, s: 0.8 + R() * 1.4, a: 0.1 + R() * 0.25 };
    return { x: 0, y: 0 };
  };
  Weather.prototype.loop = function () {
    if (!this.alive || document.hidden) return;
    var self = this, last = performance.now();
    var step = function (now) {
      if (!self.alive) return;
      var dt = Math.min(0.05, (now - last) / 1000); last = now; self.t += dt;
      self.draw(dt);
      self.raf = requestAnimationFrame(step);
    };
    cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(step);
  };
  Weather.prototype.draw = function (dt) {
    var c = this.ctx, w = this.w, h = this.h, k = this.kind, t = this.t;
    c.clearRect(0, 0, w, h);
    for (var i = 0; i < this.p.length; i++) {
      var p = this.p[i];
      if (k === 'rain') {
        p.y += p.v * dt; p.x -= p.v * dt * 0.18;
        if (p.y > h + 20) this.p[i] = this.make(false);
        c.strokeStyle = 'rgba(190,210,235,' + p.a + ')'; c.lineWidth = 1;
        c.beginPath(); c.moveTo(p.x, p.y); c.lineTo(p.x + p.l * 0.18, p.y - p.l); c.stroke();
      } else if (k === 'embers' || k === 'ash') {
        p.x += (p.vx + Math.sin(t * 1.6 + p.ph) * 8) * dt; p.y += p.vy * dt; p.life += dt * 0.25;
        if (p.y < -10 || p.life > 1.3) this.p[i] = this.make(false);
        var a = p.a * Math.max(0, Math.min(1, 1.3 - p.life));
        c.fillStyle = k === 'ash' ? 'rgba(200,190,180,' + a * 0.6 + ')' : 'rgba(' + (230 + Math.round(Math.sin(p.ph) * 20)) + ',' + (140 + Math.round(p.s * 20)) + ',70,' + a + ')';
        c.fillRect(Math.round(p.x), Math.round(p.y), p.s, p.s);
      } else if (k === 'fireflies') {
        p.ph += dt * p.sp; var fx = p.x + Math.sin(p.ph * 1.3) * 18, fy = p.y + Math.cos(p.ph) * 12;
        var fa = 0.35 + 0.65 * Math.max(0, Math.sin(p.ph * 2.2));
        var g = c.createRadialGradient(fx, fy, 0, fx, fy, p.s * 5);
        g.addColorStop(0, 'rgba(244,214,138,' + fa + ')'); g.addColorStop(1, 'rgba(244,214,138,0)');
        c.fillStyle = g; c.fillRect(fx - p.s * 5, fy - p.s * 5, p.s * 10, p.s * 10);
      } else if (k === 'wisps') {
        p.ph += dt * p.sp; var wx = p.x + Math.sin(p.ph) * 40, wy = p.y + Math.sin(p.ph * 1.7) * 14;
        var wa = 0.25 + 0.35 * Math.max(0, Math.sin(p.ph * 1.3));
        var g2 = c.createRadialGradient(wx, wy, 0, wx, wy, p.s * 7);
        g2.addColorStop(0, 'rgba(159,215,235,' + wa + ')'); g2.addColorStop(1, 'rgba(159,215,235,0)');
        c.fillStyle = g2; c.fillRect(wx - p.s * 7, wy - p.s * 7, p.s * 14, p.s * 14);
      } else if (k === 'dust') {
        p.x += p.vx * dt; p.y += p.vy * dt; if (p.x > w + 5) { p.x = -5; p.y = Math.random() * h; }
        c.fillStyle = 'rgba(244,214,138,' + p.a + ')'; c.fillRect(p.x, p.y, p.s, p.s);
      }
    }
  };
  Weather.prototype.destroy = function () {
    this.alive = false; cancelAnimationFrame(this.raf);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVis);
  };

  /* scene(el, {img, weather, light, focus}) builds layered DOM inside el. */
  function scene(el, o) {
    if (!el) return { set: function () {}, destroy: function () {} };
    o = o || {};
    el.classList.add('qo-scene');
    el.innerHTML = '';
    var img = document.createElement('div'); img.className = 'qo-scene__img';
    var light = document.createElement('div'); light.className = 'qo-scene__light';
    var fog = document.createElement('div'); fog.className = 'qo-scene__fog';
    var cv = document.createElement('canvas'); cv.className = 'qo-scene__fx'; cv.setAttribute('aria-hidden', 'true');
    var vig = document.createElement('div'); vig.className = 'qo-scene__vig';
    /* Pixel scenery (quest-one-v2-scenes.js) draws here when a scene names one; the painting layer then stays empty. */
    var pxHost = document.createElement('div'); pxHost.className = 'qo-scene__px';
    el.appendChild(img); el.appendChild(pxHost); el.appendChild(fog); el.appendChild(light); el.appendChild(cv); el.appendChild(vig);
    var weather = null, pxInst = null;
    function set(n) {
      n = n || {};
      if (n.img !== undefined) {
        if (n.img) { var pre = new Image(); pre.decoding = 'async'; pre.src = n.img; img.style.backgroundImage = 'url("' + n.img + '")'; }
        else img.style.backgroundImage = 'none';
      }
      if (n.focus) img.style.backgroundPosition = n.focus;
      if (n.light !== undefined) el.setAttribute('data-light', n.light || 'none');
      if (n.fog !== undefined) el.setAttribute('data-fog', n.fog ? '1' : '0');
      if (n.weather !== undefined) {
        if (weather) { weather.destroy(); weather = null; }
        var ctx = cv.getContext('2d'); ctx.clearRect(0, 0, cv.width, cv.height);
        if (n.weather && !RM()) weather = new Weather(cv, n.weather);
      }
      if (n.mood !== undefined) el.setAttribute('data-mood', n.mood || '');
      if (n.px !== undefined) {
        var S2 = window.QOScenes;
        if (n.px && S2 && S2.mount) {
          try {
            if (pxInst && pxInst.setKey) pxInst.setKey(n.px); else pxInst = S2.mount(pxHost, n.px, { reduced: RM() });
            img.style.backgroundImage = 'none'; el.setAttribute('data-px', n.px);
          } catch (e) { pxInst = null; }
        } else { if (pxInst) { try { pxInst.destroy(); } catch (e) {} pxInst = null; } el.removeAttribute('data-px'); }
      }
    }
    set(o);
    return { set: set, destroy: function () { if (weather) weather.destroy(); if (pxInst) { try { pxInst.destroy(); } catch (e) {} } }, el: el };
  }

  /* ---------- Screen feedback ---------- */
  function shake(el, strength) {
    if (!el || RM()) return;
    var s = strength || 6; el.style.setProperty('--qo-shake', s + 'px');
    el.classList.remove('qo-shake'); void el.offsetWidth; el.classList.add('qo-shake');
    setTimeout(function () { el.classList.remove('qo-shake'); }, 480);
  }
  var flashEl = null;
  function flash(color, ms) {
    if (!flashEl) { flashEl = document.createElement('div'); flashEl.className = 'qo-flash'; document.body.appendChild(flashEl); }
    flashEl.style.background = color || 'rgba(232,198,116,.35)';
    flashEl.style.transition = 'none'; flashEl.style.opacity = RM() ? '0.35' : '1';
    void flashEl.offsetWidth;
    flashEl.style.transition = 'opacity ' + (ms || 420) + 'ms ease-out'; flashEl.style.opacity = '0';
  }
  var crackEl = null;
  /* A glass-crack burst drawn on a canvas: jagged fractures grow out of the impact point, branch,
     get joined by spiderweb rings near the centre, catch light on a few facets, then fade away. */
  var crackCv = null, crackTimer = 0;
  function crack(on, o) {
    o = o || {};
    if (!on) {
      if (crackCv) { var cv0 = crackCv; crackCv = null; cv0.classList.add('off'); setTimeout(function () { try { cv0.remove(); } catch (e) {} }, 700); }
      return;
    }
    if (crackCv) { try { crackCv.remove(); } catch (e) {} crackCv = null; }
    var W = window.innerWidth, H = window.innerHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
    var cv = document.createElement('canvas'); cv.className = 'qo-crackcv'; cv.setAttribute('aria-hidden', 'true');
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    document.body.appendChild(cv); crackCv = cv;
    var c = cv.getContext('2d'); c.scale(dpr, dpr);
    var at = o.at && o.at.getBoundingClientRect ? o.at.getBoundingClientRect() : null;
    var cx = at ? at.left + at.width / 2 : W / 2, cy = at ? at.top + at.height * 0.28 : H * 0.34;
    var R = Math.hypot(Math.max(cx, W - cx), Math.max(cy, H - cy)) + 40;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    /* main rays, each a jagged polyline with its own branches */
    var paths = [], n = 9, k, i;
    for (k = 0; k < n; k++) {
      var ang = (k / n) * Math.PI * 2 + rnd(-0.2, 0.2), pts = [[cx, cy]], d = 0, x = cx, y = cy, a2 = ang, len = R * (k % 3 === 0 ? rnd(0.75, 1) : rnd(0.28, 0.6));
      while (d < len) { var step = rnd(34, 80); a2 = ang + rnd(-0.1, 0.1); x += Math.cos(a2) * step; y += Math.sin(a2) * step; d += step; pts.push([x, y, d]); }
      paths.push({ pts: pts, w: rnd(1.6, 2.4), d0: 0 });
      var nb = 1 + (Math.random() * 2 | 0);
      for (i = 0; i < nb; i++) {
        var from = pts[1 + (Math.random() * Math.max(1, pts.length - 2) | 0)] || pts[1], ba = ang + (Math.random() < 0.5 ? -1 : 1) * rnd(0.4, 0.8), bp = [[from[0], from[1]]], bd = 0, bx = from[0], by = from[1], blen = rnd(30, 110);
        while (bd < blen) { var st2 = rnd(16, 40); var aa = ba + rnd(-0.12, 0.12); bx += Math.cos(aa) * st2; by += Math.sin(aa) * st2; bd += st2; bp.push([bx, by, (from[2] || 0) + bd]); }
        paths.push({ pts: bp, w: rnd(0.9, 1.3), d0: from[2] || 0 });
      }
    }
    /* spiderweb rings: short cracks that join neighbouring rays near the impact */
    var rings = [];
    [rnd(22, 32), rnd(52, 70), rnd(100, 130)].forEach(function (rr, ri) {
      for (k = 0; k < n; k++) {
        if (Math.random() < 0.18 + ri * 0.12) continue;
        var a0 = (k / n) * Math.PI * 2, a1 = ((k + 1) / n) * Math.PI * 2, r0 = rr + rnd(-8, 8), r1 = rr + rnd(-8, 8), mid = (a0 + a1) / 2, rm = (r0 + r1) / 2 + rnd(-6, 10);
        rings.push({ pts: [[cx + Math.cos(a0) * r0, cy + Math.sin(a0) * r0], [cx + Math.cos(mid) * rm, cy + Math.sin(mid) * rm], [cx + Math.cos(a1) * r1, cy + Math.sin(a1) * r1]], d: rr, w: ri === 0 ? 1.3 : ri === 1 ? 1.05 : 0.8 });
      }
    });
    /* facets: a few wedges near the centre that catch the light */
    var facets = [];
    for (k = 0; k < n; k++) if (Math.random() < 0.6) facets.push({ a0: (k / n) * Math.PI * 2, a1: ((k + 1) / n) * Math.PI * 2, r: rnd(56, 150), al: rnd(0.05, 0.14), dark: k % 2 === 1 });
    function stroke(pts, upto, w, d0) {
      c.beginPath(); c.moveTo(pts[0][0], pts[0][1]);
      for (var j = 1; j < pts.length; j++) {
        var pd = pts[j][2] != null ? pts[j][2] : d0 + j * 30;
        if (pd > upto) { var q = pts[j - 1], t = Math.max(0, Math.min(1, (upto - (q[2] != null ? q[2] : d0)) / Math.max(1, pd - (q[2] != null ? q[2] : d0)))); c.lineTo(q[0] + (pts[j][0] - q[0]) * t, q[1] + (pts[j][1] - q[1]) * t); break; }
        c.lineTo(pts[j][0], pts[j][1]);
      }
      c.lineWidth = w; c.stroke();
    }
    var t0 = performance.now(), grow = RM() ? 1 : 260;
    function draw(now) {
      if (crackCv !== cv) return;
      var p = grow === 1 ? 1 : Math.min(1, (now - t0) / grow), reach = R * (1 - Math.pow(1 - p, 2));
      c.clearRect(0, 0, W, H);
      /* impact flash */
      var fl = c.createRadialGradient(cx, cy, 0, cx, cy, 180); fl.addColorStop(0, 'rgba(235,244,255,' + (0.55 * (1 - p * 0.6)) + ')'); fl.addColorStop(1, 'rgba(160,190,255,0)');
      c.fillStyle = fl; c.fillRect(0, 0, W, H);
      facets.forEach(function (f) { if (f.r > reach) return; c.beginPath(); c.moveTo(cx, cy); c.arc(cx, cy, f.r, f.a0, f.a1); c.closePath(); c.fillStyle = f.dark ? 'rgba(4,8,18,' + (f.al * 1.6) + ')' : 'rgba(220,235,255,' + f.al + ')'; c.fill(); });
      c.lineCap = 'round'; c.lineJoin = 'round';
      /* glow pass, then the white-hot core */
      c.shadowColor = 'rgba(150,190,255,.7)'; c.shadowBlur = 5; c.strokeStyle = 'rgba(170,200,255,.22)';
      paths.forEach(function (pa) { stroke(pa.pts, reach, pa.w * 2, pa.d0); });
      rings.forEach(function (rg) { if (rg.d < reach) stroke(rg.pts, 1e9, rg.w * 2, 0); });
      c.shadowBlur = 0; c.strokeStyle = 'rgba(245,250,255,.92)';
      paths.forEach(function (pa) { stroke(pa.pts, reach, pa.w * 0.45, pa.d0); });
      rings.forEach(function (rg) { if (rg.d < reach) stroke(rg.pts, 1e9, rg.w * 0.55, 0); });
      /* the far ends fade out, so the break reads as glass around one point, not lightning */
      var fade = c.createRadialGradient(cx, cy, 120, cx, cy, R * 0.9); fade.addColorStop(0, 'rgba(0,0,0,0)'); fade.addColorStop(1, 'rgba(0,0,0,1)');
      c.globalCompositeOperation = 'destination-out'; c.fillStyle = fade; c.fillRect(0, 0, W, H); c.globalCompositeOperation = 'source-over';
      if (p < 1) requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
    clearTimeout(crackTimer);
    if (o.hold) crackTimer = setTimeout(function () { crack(false); }, o.hold);
  }
  function burst(x, y, o) {
    o = o || {};
    try {
      if (window.hohFx && window.hohFx.available) {
        window.hohFx.emit(o.kind || 'sparks', { x: x, y: y, n: o.n || 22, color: o.color || '#e8c674', big: o.big ? 1 : 0 });
        return;
      }
    } catch (e) {}
  }
  function center(el) {
    if (!el) return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function numberPop(anchorEl, text, o) {
    o = o || {};
    var c = center(anchorEl), n = document.createElement('div');
    n.className = 'qo-numpop' + (o.cls ? ' ' + o.cls : ''); n.textContent = text;
    n.style.left = c.x + 'px'; n.style.top = (c.y + (o.dy || 0)) + 'px';
    document.body.appendChild(n);
    setTimeout(function () { try { n.remove(); } catch (e) {} }, RM() ? 900 : 1100);
  }
  /* flyChip: a modifier label flies from a source element into the target (the dice total). */
  function flyChip(fromEl, toEl, label, o) {
    return new Promise(function (resolve) {
      o = o || {};
      var a = center(fromEl), b = center(toEl);
      var chip = document.createElement('div'); chip.className = 'qo-flychip'; chip.textContent = label;
      chip.style.left = a.x + 'px'; chip.style.top = a.y + 'px';
      document.body.appendChild(chip);
      if (RM()) { setTimeout(function () { chip.remove(); resolve(); }, 250); return; }
      requestAnimationFrame(function () {
        chip.style.transition = 'transform 520ms cubic-bezier(.3,.7,.2,1), opacity 520ms';
        chip.style.transform = 'translate(' + (b.x - a.x) + 'px,' + (b.y - a.y) + 'px) scale(.72)';
        chip.style.opacity = '0.2';
      });
      setTimeout(function () { try { chip.remove(); } catch (e) {} burst(b.x, b.y, { n: 8 }); resolve(); }, 540);
    });
  }

  /* ---------- Share card (1080 x 1350, the ad format) ---------- */
  function fontsReady() {
    try {
      return Promise.race([
        /* A font file that fails to load must not stop the card: it draws with the fallback faces instead. */
        Promise.all([
          document.fonts.load('900 80px Cinzel'), document.fonts.load('italic 500 40px "Cormorant Garamond"'), document.fonts.load('600 28px Inter')
        ]).catch(function () {}),
        new Promise(function (r) { setTimeout(r, 1500); })
      ]);
    } catch (e) { return Promise.resolve(); }
  }
  function wrap(ctx, text, maxW) {
    var words = String(text || '').split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = words[i]; } else line = test;
    }
    if (line) lines.push(line);
    return lines;
  }
  function loadImg(src) {
    return new Promise(function (res) {
      if (!src) return res(null);
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = src;
    });
  }
  function shareCard(d) {
    return fontsReady().then(function () { return Promise.all([loadImg(d.iconURL), d.imageURL ? loadImg(d.imageURL) : null]); }).then(function (imgs) {
      var icon = imgs[0], photo = imgs[1];
      var W = 1080, H = 1350, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var c = cv.getContext('2d'), hue = typeof d.hue === 'number' ? d.hue : 44;
      function hsl(s, l, a) { return 'hsla(' + hue + ',' + s + '%,' + l + '%,' + a + ')'; }
      function rr(x, y, w, h, r) { c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); }
      /* The same card as the page: one rounded gold edge, a family tint, a clean art window. */
      var bg = c.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, '#17131f'); bg.addColorStop(0.55, '#0d0b13'); bg.addColorStop(1, '#08070c');
      c.fillStyle = bg; c.fillRect(0, 0, W, H);
      var top = c.createRadialGradient(W / 2, 0, 40, W / 2, 0, 900); top.addColorStop(0, hsl(70, 45, 0.32)); top.addColorStop(1, hsl(70, 45, 0));
      c.fillStyle = top; c.fillRect(0, 0, W, H);
      rr(34, 34, W - 68, H - 68, 44); c.strokeStyle = 'rgba(232,198,116,0.9)'; c.lineWidth = 5; c.stroke();
      c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      c.fillStyle = hsl(55, 74, 1); c.font = '600 26px Inter, Arial, sans-serif';
      var eb = 'CHARACTER QUEST RESULT'; c.save(); c.translate(W / 2, 130); c.fillText(eb.split('').join(String.fromCharCode(8202)), 0, 0); c.restore();
      /* The card people save and share (Jan, 6 October 2026): the title and its line lead, large; the icon sits in the
         middle; the hero's name and details are a quiet caption with no rule above it; every part has room inside the
         gold edge. The block is measured first, then centred between the eyebrow and the footer; a long title or line
         shrinks the icon first, then the line. */
      var title = String(d.title || 'The Unnamed Hero').toUpperCase(), size = 104, lines;
      do { c.font = '900 ' + size + 'px Cinzel, Georgia, serif'; lines = wrap(c, title, W - 240); size -= 4; } while ((lines.length > 2 || lines.some(function (l) { return c.measureText(l).width > W - 240; })) && size > 44);
      size += 4;
      var tsz = 58, tl;
      function tagLines() { do { c.font = 'italic 500 ' + tsz + 'px "Cormorant Garamond", Georgia, serif'; tl = wrap(c, d.tagline || '', W - 250); tsz -= 2; } while (tl.length > 4 && tsz > 36); tsz += 2; tl = tl.slice(0, 4); }
      tagLines();
      var who = d.name || '', meta = [d.race, d.cls, d.level ? 'Level ' + d.level : ''].filter(Boolean).join('  ·  ');
      var titleH = lines.length * (size + 12) - 12, tagH = tl.length * Math.round(tsz * 1.22), famH = d.family ? 76 : 0;
      var fs = 330, gap1 = 56, gap2 = 66, gap3 = 56, capH = 36 + 40;
      var y1 = 196, y2 = H - 150;
      function total() { return titleH + gap1 + fs + gap2 + tagH + gap3 + capH + famH; }
      while (total() > y2 - y1 && fs > 220) fs -= 10;
      while (total() > y2 - y1 && tsz > 38) { tsz -= 2; tagLines(); tagH = tl.length * Math.round(tsz * 1.22); }
      var y0 = y1 + Math.max(0, (y2 - y1 - total()) / 2);
      /* title */
      var ty = y0 + size * 0.82; c.fillStyle = '#e8c674';
      c.shadowColor = 'rgba(232,198,116,0.45)'; c.shadowBlur = 24;
      c.font = '900 ' + size + 'px Cinzel, Georgia, serif';
      lines.forEach(function (l, i) { c.fillText(l, W / 2, ty + i * (size + 12)); });
      c.shadowBlur = 0;
      /* the art window with the class icon */
      var fx = (W - fs) / 2, fy = y0 + titleH + gap1;
      rr(fx, fy, fs, fs, 36); c.save(); c.clip();
      c.fillStyle = '#0c0a12'; c.fillRect(fx, fy, fs, fs);
      var ig = c.createRadialGradient(W / 2, fy + fs * 0.46, 10, W / 2, fy + fs * 0.46, fs * 0.62); ig.addColorStop(0, hsl(85, 62, 0.55)); ig.addColorStop(0.45, hsl(60, 30, 0.22)); ig.addColorStop(1, hsl(60, 30, 0));
      c.fillStyle = ig; c.fillRect(fx, fy, fs, fs);
      /* the player's own image fills the window, cropped toward the top where faces sit */
      if (photo && photo.naturalWidth) {
        var pw = photo.naturalWidth, ph = photo.naturalHeight, sc = Math.max(fs / pw, fs / ph), dw = pw * sc, dh = ph * sc;
        c.imageSmoothingEnabled = true; c.drawImage(photo, fx + (fs - dw) / 2, fy + Math.min(0, (fs - dh) * 0.22), dw, dh);
      }
      c.restore();
      if (photo && photo.naturalWidth) { rr(fx, fy, fs, fs, 36); c.strokeStyle = hsl(60, 66, 0.45); c.lineWidth = 3; c.stroke(); }
      /* The icon at 93.4 percent of its window (72 before 13 October 2026), the same 30 percent step as the page's card. */
      else if (icon) { c.imageSmoothingEnabled = false; var is = Math.round(fs * 0.934); c.drawImage(icon, (W - is) / 2, fy + (fs - is) / 2, is, is); }
      /* the line, large: what the card says about the hero */
      var gy = fy + fs + gap2 + tsz * 0.8, lh = Math.round(tsz * 1.22);
      c.font = 'italic 500 ' + tsz + 'px "Cormorant Garamond", Georgia, serif'; c.fillStyle = '#f1e8d6';
      tl.forEach(function (l, i) { c.fillText(l, W / 2, gy + i * lh); });
      /* then the caption: the name and the details, small (no rule above it since 6 October 2026) */
      var ry = fy + fs + gap2 + tagH + gap3 * 0.5;
      /* Names and custom races or classes can run 40 characters: shrink them to fit the card. */
      function fit(txt, weight, px, fam, max) { do { c.font = weight + ' ' + px + 'px ' + fam; px -= 2; } while (c.measureText(txt).width > max && px > 16); }
      var ny = ry + gap3 * 0.5 + 30;
      fit(who.toUpperCase(), '700', 36, 'Cinzel, Georgia, serif', W - 260); c.fillStyle = '#ece3d2'; c.fillText(who.toUpperCase(), W / 2, ny);
      fit(meta, '500', 24, 'Inter, Arial, sans-serif', W - 260); c.fillStyle = '#a99f92'; c.fillText(meta, W / 2, ny + 40);
      if (d.family) {
        var ft = ('Family of the ' + d.family).toUpperCase(); c.font = '700 21px Inter, Arial, sans-serif';
        var fw = c.measureText(ft).width + 60, fyy = ny + 40 + 62;
        rr((W - fw) / 2, fyy - 29, fw, 42, 21); c.fillStyle = hsl(60, 40, 0.22); c.fill(); c.strokeStyle = hsl(60, 66, 0.45); c.lineWidth = 2; c.stroke();
        c.fillStyle = hsl(70, 78, 1); c.fillText(ft, W / 2, fyy);
      }
      c.font = '700 26px Cinzel, Georgia, serif'; c.fillStyle = '#c9a84c'; c.fillText('FRAMEDFANTASY', W / 2, H - 96);
      c.font = '500 22px Inter, Arial, sans-serif'; c.fillStyle = '#8b8178'; c.fillText('Find yours at framedfantasy.com/quest', W / 2, H - 62);
      var png = cv.toDataURL('image/png');
      keepCopy(png, cv);
      return png;
    });
  }
  /* The upload copy (14 October 2026): the same card as a JPEG at 0.88, about 150 to 250 KB against the PNG's 1.1 MB,
     which took about 10 s to upload on a phone. Drawn from the card's canvas in idle time after the card appears (or at
     once if the claim asks first), then the canvas is let go. Only the newest card keeps a copy. The PNG stays the card
     players save. */
  var cardCopy = null;
  function keepCopy(png, cv) {
    var rec = cardCopy = { png: png, cv: cv, jpg: '' };
    function go() { jpgOf(rec); }
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 400);
  }
  function jpgOf(rec) {
    if (!rec.jpg && rec.cv) { try { rec.jpg = rec.cv.toDataURL('image/jpeg', 0.88); } catch (e) { rec.jpg = ''; } rec.cv = null; }
    return rec.jpg;
  }
  function uploadCopy(png) { return cardCopy && cardCopy.png === png ? jpgOf(cardCopy) || png : png; }

  /* ---------- Save overlay (history-safe for in-app browsers) ---------- */
  function dataURLtoBlob(u) {
    var p = u.split(','), mime = (p[0].match(/:(.*?);/) || [])[1] || 'image/png', b = atob(p[1]), n = b.length, a = new Uint8Array(n);
    while (n--) a[n] = b.charCodeAt(n);
    return new Blob([a], { type: mime });
  }
  function isInApp() { var ua = navigator.userAgent || ''; return /FBAN|FBAV|FB_IAB|Instagram|Line\/|TikTok|Snapchat|; wv\)/i.test(ua); }
  function isIOS() { var ua = navigator.userAgent || ''; return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1); }
  function isAndroid() { return /Android/i.test(navigator.userAgent || ''); }
  function saveImage(dataURL, fileName, opts) {
    opts = opts || {};
    var blob = dataURLtoBlob(dataURL), file = null;
    try { file = new File([blob], (fileName || 'hero') + '.png', { type: 'image/png' }); } catch (e) {}
    var shareFirst = opts.share && file && navigator.canShare && navigator.canShare({ files: [file] });
    if (shareFirst) {
      return navigator.share({ files: [file], title: opts.title || 'My hero', text: opts.text || '' }).catch(function (e) { if (!e || (e.name !== 'AbortError' && e.name !== 'InvalidStateError')) overlay(blob, fileName, opts); });
    }
    /* iPhone Safari saves a downloaded PNG to Files, not Photos: its share sheet has Save Image. */
    if (!shareFirst && isIOS() && !isInApp() && file && navigator.canShare && navigator.canShare({ files: [file] })) {
      return navigator.share({ files: [file] }).catch(function (e) { if (!e || (e.name !== 'AbortError' && e.name !== 'InvalidStateError')) overlay(blob, fileName, opts); });
    }
    if (!isInApp() && !isIOS() && !opts.forceOverlay) {
      var url = URL.createObjectURL(blob), a = document.createElement('a'); a.href = url; a.download = (fileName || 'hero') + '.png';
      document.body.appendChild(a); a.click(); setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 1500);
      return Promise.resolve();
    }
    overlay(blob, fileName, opts); return Promise.resolve();
  }
  function overlay(blob, fileName, opts) {
    var url = URL.createObjectURL(blob);
    var o = document.createElement('div'); o.className = 'qo-saveov'; o.setAttribute('role', 'dialog'); o.setAttribute('aria-label', 'Save your card');
    var how = isAndroid() ? 'Press and hold the card, then choose <b>Download image</b>.' : 'Press and hold the card, then choose <b>Save image</b> or <b>Add to Photos</b>.';
    if (opts && opts.share) how += ' Then send it to your party from your photos.';
    o.innerHTML = '<div class="qo-saveov__in"><p class="qo-saveov__hint">' + how + '</p><img alt="Your archetype card" /><button type="button" class="qo-btn qo-btn--ghost">Done</button></div>';
    o.querySelector('img').src = url;
    document.body.appendChild(o);
    var closed = false;
    function close(fromPop) {
      if (closed) return; closed = true;
      o.classList.add('out'); setTimeout(function () { o.remove(); URL.revokeObjectURL(url); }, 220);
      window.removeEventListener('popstate', onPop);
      /* The app's own Back handling skips the history step this close takes. */
      window.__qoSaveClosedAt = Date.now();
      if (!fromPop) { try { history.back(); } catch (e) {} }
    }
    function onPop() { close(true); }
    try { history.pushState({ qoSave: 1 }, ''); window.addEventListener('popstate', onPop); } catch (e) {}
    o.querySelector('button').addEventListener('click', function () { close(false); });
  }

  window.QOFx = { scene: scene, shake: shake, flash: flash, crack: crack, burst: burst, center: center, numberPop: numberPop, flyChip: flyChip, shareCard: shareCard, uploadCopy: uploadCopy, saveImage: saveImage, isInApp: isInApp, reduced: RM };
})();
